var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotobook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.333 136.666H26.6667C19.3333 136.666 13.3333 130.666 13.3333 123.333V36.6663C13.3333 29.333 19.3333 23.333 26.6667 23.333H133.333C140.667 23.333 146.667 29.333 146.667 36.6663V123.333C146.667 130.666 140.667 136.666 133.333 136.666Z",
    fill: "#629E94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.667 63.333C122.19 63.333 126.667 58.8559 126.667 53.333C126.667 47.8102 122.19 43.333 116.667 43.333C111.144 43.333 106.667 47.8102 106.667 53.333C106.667 58.8559 111.144 63.333 116.667 63.333Z",
    fill: "#FFF9C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6667 53.333L30 106.666H103.333L66.6667 53.333Z",
    fill: "#34544F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.333 73.333L76.6667 106.666H130L103.333 73.333Z",
    fill: "#4E7E77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotobook);
export default __webpack_public_path__ + "static/media/photobook.1f6f44c0aac7cf29929d50c59bdebffb.svg";
export { ForwardRef as ReactComponent };